import { Languages, LocaleField } from 'common/types';

export const availableLanguagesWithInfo: Array<{ lang: Languages; info: string }> = [
	{ lang: 'en', info: 'rentle-free' },
	{ lang: 'fi', info: 'rentle-free' },
	{ lang: 'de', info: 'rentle-free' },
	{ lang: 'cs', info: 'rentle-free' },
	{ lang: 'es', info: 'rentle-free' },
	{ lang: 'et', info: 'rentle-free' },
	{ lang: 'it', info: 'in-store & online' },
	{ lang: 'sv', info: 'in-store & online' },
	{ lang: 'ru', info: 'in-store & online' },
	{ lang: 'sk', info: 'in-store & online' },
	{ lang: 'nl', info: 'in-store & online' },
	{ lang: 'hu', info: 'in-store & online' },
	{ lang: 'no', info: 'in-store & online' },
	{ lang: 'fr', info: 'in-store & online' },
	{ lang: 'da', info: 'in-store & online' },
	{ lang: 'lt', info: 'in-store & online' },
	{ lang: 'pl', info: 'in-store & online' },
	{ lang: 'sl', info: 'in-store & online' },
];

export const getLocaleFieldOrInitialValue = (field: LocaleField | undefined) =>
	field ?? { def: '' };

export const updateLocaleField = (
	field: LocaleField | undefined,
	value: string,
	defaultLanguage?: Languages,
): LocaleField => {
	return defaultLanguage
		? {
				...field,
				def: value,
				[defaultLanguage]: value,
		  }
		: {
				...field,
				def: value,
		  };
};
